export default __webpack_public_path__ + "static/media/Office Map.732f8149.svg";